import { render, staticRenderFns } from "./PendingApprovalResult.vue?vue&type=template&id=1ceaa878&scoped=true&"
import script from "./PendingApprovalResult.vue?vue&type=script&lang=ts&"
export * from "./PendingApprovalResult.vue?vue&type=script&lang=ts&"
import style0 from "./PendingApprovalResult.vue?vue&type=style&index=0&id=1ceaa878&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ceaa878",
  null
  
)

export default component.exports